<template>
  <popover
    placement="bottom"
    trigger="hover-focus"
    custom-class="popover-as-tooltip avatar-popover"
  >
    <span
      :class="[
        'user-initials-badge',
        'fs-exclude',
        `user-initials-${userUuid || 'unknown'}`,
        !disableTooltip ? 'focusable' : '',
        userUuid === userId ? 'me' : 'other'
      ]"
      :aria-label="disableTooltip ? undefined : `${userRole}: ${userName}`"
      :aria-hidden="disableTooltip ? 'true' : undefined"
      :tabindex="disableTooltip ? '-1' : '0'">
      {{ userInitial }}
    </span>
    <template slot="popover" v-if="!disableTooltip">
      <p class="fs-exclude">{{ userName }} <span v-if="userUuid === userId">(Me)</span></p>
      <p class="fs-exclude">{{ userEmail }}</p>
    </template>
  </popover>
</template>

<script>
import { mapGetters } from 'vuex'
const unknownUserName = 'Unknown'

export default {
  name: 'UserAvatar',
  props: {
    userInfo: {
      type: Object,
      default: () => ({
        name: unknownUserName,
        email: '',
        role: 'none',
        uuid: ''
      })
    },
    disableTooltip: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('user', ['userId']),
    userName() {
      return this.userInfo?.name || unknownUserName
    },
    userInitial() {
      if (this.userName) {
        const trimmedName = this.userName.trim()
        if (trimmedName) {
          return trimmedName.charAt(0).toUpperCase()
        }
      }
      return unknownUserName.charAt(0).toUpperCase()
    },
    userEmail() {
      return this.userInfo?.email || ''
    },
    userRole() {
      return this.userInfo?.role || 'none'
    },
    userUuid() {
      return this.userInfo?.uuid || ''
    },
  }
}
</script>

<style scoped lang="scss">
.user-initials-badge {
  display: flex;
  width: 1.75rem;
  height: 1.75rem;
  justify-content: center;
  align-items: center;
  border-radius: var(--radius-round, 624.9375rem);
  text-align: center;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.125rem; /* 150% */
  margin: 0 0.25rem;
  outline: none;

  &.focusable {
    cursor: help;

    &:focus {
      outline: 2px solid;
      outline-offset: 2px;
    }
  }

  &.me {
    background: var(--blue-default, #00769F);
    color: #FFFFFF;
    border: 1px solid var(--blue-default, #00769F);

    &.focusable {
      &:hover {
        background: var(--blue-hover, #005A7A);
      }

      &:focus {
        background: var(--blue-hover, #005A7A);
        border-color: var(--blue-default, #00769F);
      }
    }
  }

  &.other {
    border: 1px solid var(--borders-toolkit-blue-hover, #013E59);
    background: #FFFFFF;
    color: var(--blue-default, #00769F);

    &.focusable {
      &:hover {
        background: #E6E6E6;
      }

      &:focus {
        background: #E6E6E6;
        border-color: var(--borders-toolkit-blue-hover, #013E59);
      }
    }
  }
}

.current-user-bg {
  background-color: var(--blue-default, #00769F);
  color: #FFFFFF;
}
</style>

<style lang="less">
.avatar-popover {
  .popover-content {
    padding: 6px 12px !important;
  }
  .fs-exclude {
    margin: 0;
    padding: 0;
  }
}
</style>
